<template>
  <div class="w-5/6 lg:w-3/5 mx-auto">
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <h1 class="text-3xl text-center">最终用户使用协议</h1>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <font face="标楷体"
        >欢迎使用北京归源易生软件开发有限公司（以下简称“我公司”）开发的《归源易生……》软件产品及相关各项服务(下称“归源平台”)。您(下称“用户”)在使用之前，请仔细阅读本《最终用户使用协议》(下称“本协议”)中的所有内容，特别是其中免除或者限制我公司责任的免责条款和对用户的权利限制条款。如您不同意本协议的任何条款内容，请不要继续使用，否则您的使用行为将被视为您已仔细阅读并充分理解本协议的所有内容，同意并接受本协议全部条款的约定，本协议即构成您与我公司之间就您使用本应用产品所达成的协议，具有法律效力。此后您不得以未阅读本协议内容或类似言辞做任何形式的抗辩。</font
      >
    </p>
    <p>
      <font face="标楷体"
        ><b
          ><u
            >鉴于归源平台为医疗行业的专用软件，对软件使用者具有极高的专业性要求，请务必完整阅读本协议并完全理解本协议所述的全部内容。请注意：归源平台所提供的各项辅助功能，仅根据中医经典理论及已经验证的药物配伍禁忌等作出辅助性提示，无法涵盖全部。开具处方等医疗活动最终决策由使用本系统的医师自行作出。</u
          ></b
        ><b><u></u></b
      ></font>
    </p>
    <p>
      <font face="标楷体"
        ><b><u>本协议1</u></b
        ><b><u>.1</u></b
        ><b><u>条、1</u></b
        ><b><u>.4</u></b
        ><b><u>条、3</u></b
        ><b><u>.1</u></b
        ><b><u>条、5</u></b
        ><b><u>.6</u></b
        ><b><u>条为本协议特别强调条款，请务必完整反复阅读并确保完全理解。</u></b
        ><b><u></u></b
      ></font>
    </p>
    <p>
      <b
        ><font face="标楷体"><u></u></font
      ></b>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1&nbsp;<!--[endif]--><b>用户使用规则</b><b></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.1&nbsp;<!--[endif]-->使用归源平台，用户必须：</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.1.1&nbsp;<!--[endif]-->认真阅读并知晓归源平台产品介绍，遵守本协议和相关操作规则。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.1.2&nbsp;<!--[endif]-->提供设备，如个人电脑、手机或其他上网设备。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.1.3&nbsp;<!--[endif]--><b
          ><u
            >遵守中华人民共和国相关法律法规，具备执业医师或乡村医生资格。执业助理医师在使用本软件时应在执业医师的指导下使用。</u
          ></b
        ><b><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.1.4&nbsp;<!--[endif]--><b><u>符合上述1</u></b
        ><b><u>.1.3</u></b
        ><b
          ><u
            >条资格的执业医师、乡村医生、执业助理医师在使用本软件时其资格应处于有效期内。</u
          ></b
        ><b><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.1.5&nbsp;<!--[endif]--><b
          ><u
            >归源平台可能对用户的真实身份采取不同方式进行核验，用户在被核验时应无条件接受并按要求提供相应证明文件。</u
          ></b
        ><b><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.2&nbsp;<!--[endif]-->用户应保证不得从事下列行为：<u></u
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.2.1&nbsp;<!--[endif]-->修改、翻译、注释、改编、整理、演绎归源平台。<b
          ><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.2.2&nbsp;<!--[endif]-->复制、翻拷、传播和陈列本应用产品的程序、使用手册和(或)其他图文音像资料的全部或部分内容。<b
          ><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.2.3&nbsp;<!--[endif]-->通过反向工程、反向编译、反汇编或其他任何手段对归源平台进行分析、修改、攻击、衍生。<b
          ><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.2.4&nbsp;<!--[endif]-->通过任何方式探测、拦截、获取、使用归源平台源代码及/或存储于归源平台中的任何信息。<b
          ><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.2.5&nbsp;<!--[endif]-->创作归源平台的派生、衍生作品。<b><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.2.6&nbsp;<!--[endif]-->删除、掩盖或更改我公司或任何第三方的版权声明、商标或其它知识产权声明;<b
          ><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.2.7&nbsp;<!--[endif]-->删除、掩盖或更改归源平台所展现的任何信息;<b
          ><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.2.8&nbsp;<!--[endif]-->利用归源平台可能存在的技术缺陷或漏洞而以任何形式为自己或他人谋利或者从事其他不正当行为;<b
          ><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.2.9&nbsp;<!--[endif]-->使用任何方式或方法、试图攻击提供归源平台及相关各项服务的相关服务器、路由器、交换机以及其他设备，以达到非法获得或修改未经授权的数据资料、影响正常的归源平台服务秩序，以及其他危害性目的的行为;<b
          ><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.2.10&nbsp;<!--[endif]-->通过异常或者非法方法使用归源平台及其相关各项服务，恶意破坏归源平台，扰乱正常的服务秩序或者实施其他不正当行为;<b
          ><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.2.11&nbsp;<!--[endif]-->任何方式破坏、干扰归源平台及其相关各项服务，或影响我公司品牌形象、公司利益的行为。<b
          ><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.3&nbsp;<!--[endif]-->用户在使用归源平台时，不得损害、禁用、影响我公司的其他服务或使我公司的其他服务负担过重，也不得影响任何其它方享用我公司的其他服务。如果用户对归源平台有任何意见，或有如何改进的建议，可向我公司提出；<b
          ><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.4&nbsp;<!--[endif]--><b><u>特殊条款</u></b
        ><b><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.4.1&nbsp;<!--[endif]--><b
          ><u
            >在用户使用归源平台时，应严格遵守国家法律法规，不得泄露患者的个人肌体特征、健康状况、遗传基因、病史病历等隐私信息；</u
          ></b
        ><b><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.4.2&nbsp;<!--[endif]--><b><u>在用户使用归源平台时</u></b
        ><b
          ><u
            >，对患者的健康档案、电子病历、医学科学数据、医学影像数据、对病人健康观测实时数据、网站数据、医疗保险数据等电子数据应严格保密，未经患者本人同意且经所在医疗机构或政府监管部门许可不得以任何方式私自拷贝、伪造、删改、展示、传播或使之公之于众；</u
          ></b
        ><b><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.4.3&nbsp;<!--[endif]--><b
          ><u
            >未经所在医疗机构及政府监管部门许可，不得将上述电子数据传播至境外；</u
          ></b
        ><b><u></u></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >1.4.4&nbsp;<!--[endif]--><b
          ><u
            >如用户在诊疗过程中涉及超出一般处方剂量使用药品、毒麻药品等特殊情况的，应严格遵守国家法律法规谨慎处理；</u
          ></b
        ><b><u></u></b
      ></font>
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >2&nbsp;<!--[endif]--><b>相关服务</b><b></b
      ></font>
    </p>
    <p>
      <font face="标楷体"
        >归源平台的相关各项服务的具体内容由我公司根据实际情况提供，我公司有权随时根据归源平台的运营情况对该等服务进行任何形式的变动、调整，并且我公司有权针对归源平台所涉及的某种特定的服务的服务内容、服务方式通过任何形式(包括但不限于系统/网页公告、系统通知等)作出声明、通知，该等声明、通知将被视为是本协议的一部分。在该等声明、通知发布后，用户如继续使用归源平台，则视为用户已知悉并同意该等声明、通知的内容。</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >3&nbsp;<!--[endif]--><b>注册资料及数据信息</b><b></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >3.1&nbsp;<!--[endif]--><b
          ><u
            >用户应向所在医疗机构提供真实有效的身份及执业信息，并由用户所在医疗机构进行核验，为用户开通使用权限。如发生错误或变更，用户应及时向所在医疗机构反馈。如我公司发现用户提供的资料不准确、不真实、不合法有效的，我公司有权终止用户继续使用归源平台的权利，并追究用户的法律责任。</u
          ></b
        ></font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >3.2&nbsp;<!--[endif]-->用户同意与注册、使用归源平台所相关的一切资料、数据和记录，包括但不限于注册信息、和相关的使用统计数据归我公司所有(用户的姓名、身份证号、电话号码等个人身份数据信息除外)。发生争议时，用户同意以我公司的系统数据为准，我公司保证该数据的真实性。</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >4&nbsp;<!--[endif]--><b>授权使用</b><b></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >4.1&nbsp;<!--[endif]-->用户所使用的归源平台及相关服务系根据我公司与用户所在医疗机构签署的合作协议授权医疗机构使用。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >4.2&nbsp;<!--[endif]-->除非经我公司事先授权，用户不得将归源平台用于任何商业用途，不得利用或通过归源平台进行任何的牟利行为。用户如果要通过、利用归源平台、对归源平台或者与归源平台有关或派生的任何资料、服务或软件进行任何商业性使用，则应与我公司联系并获得我公司的另行授权。</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >5&nbsp;<!--[endif]--><b>知识产权</b><b></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >5.1&nbsp;<!--[endif]-->我公司依法享有归源平台的一切合法权属(包括但不限于知识产权)。归源平台及其相关各项服务的全部著作权及一切其他知识产权，以及与归源平台相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图标、色彩组合、界面设计、版面框架、有关数据、印刷材料、或电子文档等均受中国知识产权相关法律法规及有关的国际条约的保护。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >5.2&nbsp;<!--[endif]-->归源平台及其相关各项服务所体现的“我公司”、“归源易生”、“归源易生”徽标(图形)和/或我公司的产品和服务标示均属于我公司及其关联公司在中国及/或其他国家/地区的商标或者注册商标。用户未经合法授权不得使用。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >5.3&nbsp;<!--[endif]-->我公司及其关联公司在涉及归源平台及相关各项服务中拥有专利权、商标权、著作权及其他知识产权。我公司及其关联公司并未因本协议或者因向用户提供归源平台及相关各项服务而授予用户任何与归源平台相关的知识产权。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >5.4&nbsp;<!--[endif]-->我公司向用户提供有关归源平台的有关服务中所包含的任何文本、图片、图形、标识、音频和/或视频资料均受著作权法、商标法和/或其它相关法律的保护，未经我公司事先书面许可，用户不得对其进行任何未经授权的使用，包括但不限于不得进行复制、发行、展览、改编、汇编、出版、传播、出售等。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >5.5&nbsp;<!--[endif]-->本协议未明确授予用户的权利均由我公司及其关联公司保留。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >5.6&nbsp;<!--[endif]--><b
          ><u
            >知识产权的特别说明：归源平台在系统中内置的各个医案、推荐处方等，系经由公共版权或公开出版途径取得，仅限于用户在所在医疗机构的正常医疗活动过程中使用，不得以其他方式对外传播。</u
          ></b
        ><b><u></u></b
      ></font>
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >6&nbsp;<!--[endif]--><b>用户隐私制度</b><b></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >6.1&nbsp;<!--[endif]-->尊重用户个人隐私是我公司的一项基本政策，对于医疗行业更甚。所以，我公司一般不会公开、编辑或透露用户的注册资料或保存在我公司服务中的非公开内容，除非我公司在诚信的基础上认为透露这些信息是必要的，包括但不限于以下几种情形：</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >6.1.1&nbsp;<!--[endif]-->根据有关法律法规的要求;</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >6.1.2&nbsp;<!--[endif]-->根据相关政府主管部门的要求;</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >6.1.3&nbsp;<!--[endif]-->遵从归源平台的服务程序所需;</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >6.1.4&nbsp;<!--[endif]-->为维护社会公众利益;</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >6.1.5&nbsp;<!--[endif]-->为维护我公司自身合法权益;</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >6.1.6&nbsp;<!--[endif]-->我公司认为必要的其他情况下。</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >7&nbsp;<!--[endif]--><b>服务条款的修改</b><b></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >7.1&nbsp;<!--[endif]-->我公司有权在必要时修改本协议条款。本协议条款一旦发生变动，我公司将通过系统公告、通知或其他我公司认为恰当之方式进行提示。用户在使用归源平台时，应当及时查阅了解修改的内容。用户如继续使用归源平台，则视为对修改内容的同意;用户在不同意修改内容的情况下，有权停止使用归源平台。</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >8&nbsp;<!--[endif]--><b>责任限制</b><b></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >8.1&nbsp;<!--[endif]-->在适用法律允许的最大范围内，我公司明确表示不提供任何其他类型的保证，不论使明示的或默示的，包括但不限于适销性、适用性、可靠性、稳定性、准确性、完整性、无病毒以及无错误的任何默示保证和责任。另外，在适用法律允许的最大范围内，我公司并不担保归源平台一定能满足用户的要求，也不担保归源平台不会被修改、中断或终止，并且对归源平台的及时性、安全性、错误发生，以及信息是否能准确、及时、顺利的传送均不作任何担保。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >8.2&nbsp;<!--[endif]-->我公司保留在归源平台中投放商业性广告及/或其他任何类型商业信息的权利。</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >9&nbsp;<!--[endif]--><b>保障</b><b></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >9.1&nbsp;<!--[endif]-->用户同意保障和维护我公司及其他用户的利益，我公司有权对用户使用归源平台的情况进行审查和监督。如用户违反法律、法规、相关政策、本协议条款，或经我公司判断用户的账号数据异常，我公司有权要求用户改正或直接采取必要的措施(包括但不限于限制用户账号的登录、限制/暂停/终止用户在归源平台中的活动/权限、终止本应用产品授权、强制离线、封停账号、更改或删除用户相关信息内容等)以消除或减轻用户不当行为造成的影响。且在此种情况下用户无权要求我公司承担任何责任，因此造成的任何法律责任或损失，均需用户自行承担。用户承担法律责任及损失的形式包括但不限于：对我公司及/或其关联公司因此遭受的任何损失，用户应全额予以赔偿，赔偿的范围包括但不限于律师费用、损害补偿费用、政府机关处罚费用和其它侵权赔偿费用等。</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >10&nbsp;<!--[endif]--><b>法律及管辖</b><b></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >10.1&nbsp;<!--[endif]-->本协议将受中华人民共和国法律的约束并依据其解释。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >10.2&nbsp;<!--[endif]-->如出现纠纷，用户和我公司一致同意将纠纷交由北京市海淀区人民法院管辖。</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >11&nbsp;<!--[endif]--><b>其他</b><b></b
      ></font>
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >11.1&nbsp;<!--[endif]-->本协议中的标题仅为方便阅读而设，不应影响本协议任何条款的解释。</font
      >
    </p>
    <p>
      <!--[if--><font face="标楷体"
        >11.2&nbsp;<!--[endif]-->如本协议中任何条款因任何原因被判定为完全或部分无效或不具有执行力的，该无效或不具有执行力的条款将被最接近原条款义务的一项有效并可执行的条款所替代，并且本协议的其余条款仍应有效并具有执行力。</font
      >
    </p>
    <p>
      <font face="标楷体"
        >我公司不行使、未能及时行使或者未充分行使本条款或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响我公司在将来行使该权利。</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
  </div>
</template>
<script>
export default {
  name: "Agreement",
};
</script>
